export default import.meta.ROLLDOWN_FILE_URL_6ttRv$LO50lh4siwzZRgfg